import { CSSProperties, FormEvent, useState } from 'react';
import { LanguageSelector, useI18n } from '../i18n';
import { ApiError, CurrentUser, api } from '../lib/api';

type Props = {
  onLogin: (user: CurrentUser) => void;
};

export function LoginPage({ onLogin }: Props) {
  const { t } = useI18n();
  const [username, setUsername] = useState('wang');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      const user = await api<CurrentUser>('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password }),
      });
      onLogin(user);
    } catch (reason) {
      setError(reason instanceof ApiError ? reason.message : t('login.failed'));
      setBusy(false);
    }
  }

  return (
    <main className="login-page tech-login-page">
      <div className="login-tech-grid" aria-hidden="true" />
      <div className="login-scan-line" aria-hidden="true" />
      <div className="login-orbit login-orbit-one" aria-hidden="true"><i /></div>
      <div className="login-orbit login-orbit-two" aria-hidden="true"><i /></div>
      <div className="login-particles" aria-hidden="true">
        {Array.from({ length: 16 }, (_, index) => (
          <i
            key={index}
            style={{
              '--particle-x': `${2 + (index * 6.1)}%`,
              '--particle-y': `${9 + ((index * 4.9) % 78)}%`,
              '--particle-duration': `${4.6 + (index * 0.23)}s`,
              '--particle-delay': `${-(index % 6) * 0.55}s`,
            } as CSSProperties}
          />
        ))}
      </div>

      <LanguageSelector className="login-language-selector" />

      <section className="login-panel login-panel-tech">
        <div className="login-brand-row">
          <div className="brand-mark">OAPM</div>
          <div className="login-brand-pulse" aria-hidden="true" />
        </div>
        <p className="eyebrow">{t('app.fullName')}</p>
        <h1>{t('login.title')}</h1>

        <form onSubmit={submit}>
          <label>
            {t('login.username')}
            <input value={username} onChange={(event) => setUsername(event.target.value)} autoComplete="username" />
          </label>
          <label>
            {t('login.password')}
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
            />
          </label>
          {error && <div className="form-error">{error}</div>}
          <button className="primary-button login-submit-button" disabled={busy} type="submit">
            {busy ? t('login.submitting') : t('login.submit')}
          </button>
        </form>
      </section>
    </main>
  );
}
